import Uppy from '@uppy/core';
import AwsS3Multipart, { AwsS3Part } from '@uppy/aws-s3-multipart';
import { CONFIG } from './config';

export const getMultiPartUploadCreator = (
    endpoint: string,
    token: string,
) => async (
    file: Uppy.UppyFile,
): Promise<{ uploadId: string; key: string }> => {
    const response = await fetch(`${CONFIG.INGESTION_API_URL}/${endpoint}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            // 'X-API-Key': ApiKey,
        },
        body: JSON.stringify({
            filename: file.name,
            // libraryId: LibraryId,
        }),
    });

    const data = await response.json();

    return {
        uploadId: data.uploadId,
        key: file.name,
    };
};

export const getUploadPartPreparer = (token: string) => async (
    _: Uppy.UppyFile,
    partData: { uploadId: string; key: string; body: Blob; number: number },
): Promise<{ url: string; headers: any }> => {
    const endpoint = `${CONFIG.UPLOAD_API_URL}/tickets/${partData.uploadId}/parts/${partData.number}`;

    const response = await fetch(endpoint, {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });

    const data = await response.json();

    return {
        url: data.uploadUrl as string,
        headers: data.headers,
    };
};

export const getMultipartUploadCompleter = (token: string) => async (
    _: Uppy.UppyFile,
    opts: { uploadId: string; key: string; parts: AwsS3Part[] },
): Promise<{}> => {
    await fetch(`${CONFIG.UPLOAD_API_URL}/tickets/${opts.uploadId}/complete`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            // 'X-API-Key': ApiKey,
        },
        body: JSON.stringify({
            partETags: opts.parts.map((part) => ({
                partNumber: part.PartNumber,
                eTag: part.ETag,
            })),
        }),
    });

    return {};
};

export const getUppyInstance = (
    endpoint: string,
    token: string,
): ReturnType<typeof Uppy> => {
    // eslint-disable-next-line new-cap
    const uppyInstance = Uppy({
        id: 'uppy',
        autoProceed: false,
        allowMultipleUploads: true,
        restrictions: {
            maxFileSize: null,
            maxNumberOfFiles: null,
            minNumberOfFiles: null,
            allowedFileTypes: null,
        },
    });

    uppyInstance.use(AwsS3Multipart, {
        limit: 4,
        createMultipartUpload: getMultiPartUploadCreator(endpoint, token),
        prepareUploadPart: getUploadPartPreparer(token),
        completeMultipartUpload: getMultipartUploadCompleter(token),
    });

    return uppyInstance;
};
